/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Orders_Cancel_Order_Dialog_TitleInputs */

const en_orders_cancel_order_dialog_title = /** @type {(inputs: Orders_Cancel_Order_Dialog_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancel Order`)
};

const es_orders_cancel_order_dialog_title = /** @type {(inputs: Orders_Cancel_Order_Dialog_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancelar pedido`)
};

/**
* | output |
* | --- |
* | "Cancel Order" |
*
* @param {Orders_Cancel_Order_Dialog_TitleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_cancel_order_dialog_title = /** @type {((inputs?: Orders_Cancel_Order_Dialog_TitleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_Cancel_Order_Dialog_TitleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_cancel_order_dialog_title(inputs)
	return es_orders_cancel_order_dialog_title(inputs)
});